import beachImage from "../assets/beach.png";
import { useLanguage } from "../lib/language";

export function NewProjectsBanner() {
  const { t, dir } = useLanguage();

  return (
    <section
      aria-label={t("newProjects")}
      className="relative h-[260px] w-full overflow-hidden"
    >
      {/* Background image */}
      <img
        src={beachImage}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/45" />

      {/* Text */}
      <div
        className="relative z-10 flex h-full items-center justify-center px-6"
        dir={dir}
      >
        <h2
          className="text-4xl font-bold tracking-wide text-white drop-shadow-lg md:text-5xl lg:text-6xl"
        >
          {t("newProjects")}
        </h2>
      </div>
    </section>
  );
}
